import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const getTableConfig = () => {
  return [
    {
      title: i18next.t('tablesLabels.title'),
      field: 'title',
      columnWidth: '200px',
    },
    {
      title: i18next.t('tablesLabels.notificationType'),
      field: 'notificationType',
      columnWidth: '140px',
    },
    {
      title: i18next.t('tablesLabels.date'),
      field: 'createdAt',
      columnWidth: '180px',
      isSorting: true,
      Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
    },
    {
      title: i18next.t('tablesLabels.message'),
      field: 'message',
      Component: value => <span dangerouslySetInnerHTML={{ __html: value }} />,
    },
    {
      title: i18next.t('tablesLabels.eventName'),
      field: 'eventName',
      columnWidth: '220px',
      isVisible: false,
    },
    {
      title: '',
      field: 'readAt',
      isVisible: false,
    },
    {
      title: '',
      field: 'id',
      isVisible: false,
    },
  ];
};

export default getTableConfig;
